import {
    Box, Button, Icon,
    Paper, Tooltip, Typography, useTheme,
    Autocomplete, CircularProgress,
    TextField
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";

import { EstatisticasService, IListaDadosTrofeusGM } from "../../shered/services/api/estatisticas/EstatisticasService";
import { Loading } from "../../shered/components/loading/Loading";
import { DataGrid, GridActionsCellItem, GridColDef, GridColumnHeaderParams } from "@mui/x-data-grid";

export const ListagemDeTroufeusGM: React.FC = () => {
    const theme = useTheme();
    const { themeName } = useAppThemeContext();
    const { debounce } = useDebounce();
    const [isLoading, setIsLoading] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [showImagemTrofeus, setShowImagemTrofeus] = useState<any>("../../trofeus_nba.png");
    const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [searchParams, SetSearchParams] = useSearchParams();
    const [opcoesAutoCompleteUsuario, setOpcoesAutoCompleteUsuario] = useState<ILstDrop[]>([]);
    const [parametroCrypt, setParametroCrypt] = useState("");
    const [showImagemTrofeu, setShowImagemTrofeu] = useState<any>("../../trofeuNBA.png");
    const [imagemTrofelConferencia, setImagemTrofelConferencia] = useState<any | null>("../../../newConferencia.png");
    const [imagemTrofelDivisao, setImagemTrofelDivisao] = useState<any | null>("../../../newDivisao.png");
    const [imagemTrofelCopinha, setImagemTrofelCopinha] = useState<any | null>("../../../newCopinha.png");
    const [imagemTrofelLiga, setImagemTrofelLiga] = useState<any | null>("../../../newLiga.png");
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [trofeusRows, setTrofeusRows] = useState<IListaDadosTrofeusGM[]>([]);
    const [lstUsuarios, setLstUsuarios] = useState<ILstDrop[]>([]);


    //const [meusJogadoresRows, setMeusJogadoresRows] = useState<IListagemMeusJogadores[]>([]);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const [errors, setErrors] = useState({
        error: false,
        nomeFranquiaRef: "",
        showImagemFranquia: ""
    });

    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [showBotaoCancelar, setShowBotaoCancelar] = useState(false);
    const [limparFiltros, setLimparFiltros] = useState(false);
    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIdComplete) return null;

        const selectedOption = opcoesAutoCompleteUsuario.find(opcao => opcao.codigo === selectedIdComplete);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete, opcoesAutoCompleteUsuario]);

    useEffect(() => {
        setIsLoading(true);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            debounce(() => {
                UtilidadeService.getTemporadas(true, Number(codigoLiga))
                    .then((result) => {
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);

                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });
                carregarDadosTrofeus(false);

            })
        }
    }, [limparFiltros]);

    const carregarDadosTrofeus = async (isFiltro: boolean) => {
        setIsLoading(true);
        setRemoveLoading(false);

        await EstatisticasService.getTrofeusGM(selectedIdComplete)
            .then((result) => {
                const lstDados = result.dado;
                setTrofeusRows(lstDados);
                let lstUsuarios = result.dado.map((f, i) => ({ codigo: f.codigo_Usuario, label: `${f.nome_Usuario} (${f.posicao})` }));
                setLstUsuarios(lstUsuarios.sort((a, b) => a.label > b.label ? 1 : -1));
                if (isFiltro === false)
                    setOpcoesAutoCompleteUsuario(lstUsuarios.sort((a, b) => a.label > b.label ? 1 : -1));
                setIsLoading(false);
                setRemoveLoading(true);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

                setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            });

        setIsLoading(false);
        setRemoveLoading(true);
    }


    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const columnsGeral: GridColDef[] = [
        {
            field: 'posicao',
            headerName: 'POSIÇÃO',
            flex: 1,
            minWidth: 50,
            maxWidth: 90,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'foto_Usuario',
            headerName: 'FOTO',
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            flex: 1,
            minWidth: 60,
            maxWidth: 100,
            align: 'center',
            headerAlign: 'center',
            headerClassName: 'super-app-theme--header',
            renderCell: (params) =>
                params.value !== null && params.value !== undefined
                    ? <img
                        src={params.value}
                        alt="foto"
                        width={UtilidadeService.isMobile() ? 30 : 40}
                        height={UtilidadeService.isMobile() ? 35 : 45}

                    />
                    : <img
                        src={semImagem}
                        alt="Semfoto"
                        width={UtilidadeService.isMobile() ? 30 : 40}
                        height={UtilidadeService.isMobile() ? 35 : 45}

                    />,
        },
        {
            field: 'nome_Usuario',
            headerName: 'NOME',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 150,
            editable: true,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {

                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },

        },
        {
            field: 'quantidade_Titulo_Liga',
            renderHeader: (params: GridColumnHeaderParams) => (
                <img
                    src={imagemTrofelLiga}
                    width={UtilidadeService.isMobile() ? 40 : 80}
                    height={UtilidadeService.isMobile() ? 25 : 45}
                    alt="lig"
                />
            ),
            //headerName: 'LIGA',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 80,
            maxWidth: 100,
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'quantidade_Titulo_Conferencia',
            renderHeader: (params: GridColumnHeaderParams) => (
                <img
                    src={imagemTrofelConferencia}
                    width={UtilidadeService.isMobile() ? 25 : 50}
                    height={UtilidadeService.isMobile() ? 30 : 55}
                    alt="conf"
                />
            ),
            //headerName: 'CONFERÊNCIA',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 80,
            maxWidth: 100,
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'quantidade_Titulo_Divisao',
            renderHeader: (params: GridColumnHeaderParams) => (
                <img
                    src={imagemTrofelDivisao}
                    width={UtilidadeService.isMobile() ? 55 : 85}
                    height={UtilidadeService.isMobile() ? 25 : 50}
                    alt="div"
                />
            ),
            //headerName: 'DIVISÃO',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 80,
            maxWidth: 100,
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'quantidade_Titulo_Copinha',
            renderHeader: (params: GridColumnHeaderParams) => (
                <img
                    src={imagemTrofelCopinha}
                    width={UtilidadeService.isMobile() ? 55 : 42}
                    height={UtilidadeService.isMobile() ? 25 : 45}
                    style={{paddingTop:"5px"}}
                    alt="div"
                />
            ),
            //headerName: 'COPINHA',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 80,
            maxWidth: 100,
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'actions',
            headerName: 'AÇÃO',
            headerClassName: 'super-app-theme--header',
            type: 'actions',
            flex: 1,
            minWidth: 60,
            maxWidth: 100,
            editable: false,
            getActions: (params) => [
                <GridActionsCellItem
                    icon={<Tooltip title="Minha Galeria"><Icon>collections</Icon></Tooltip>}
                    label="Galeria"
                    onClick={() => handleGaleria(params.row.codigo_Usuario)}

                />,
            ]
        }
    ];

    const handleGaleria = (codigoUsuario: number) => {

        let resultadoCrypt = UtilidadeService.crypt(`${codigoUsuario}`);
        setParametroCrypt(resultadoCrypt);
        navigate(`/liga/estatisticas/galeria/detalhe/${resultadoCrypt}`);
    }

    const handleLimparFiltros = () => {
        setSelectedIdComplete(0);
        setShowBotaoCancelar(false);
        setLimparFiltros(true);
    }

    return (
        <LayoutBaseDePagina
            titulo={`SALA DE TROFÉUS GM`}
            showLogoImg={showImagemTrofeu}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
                    <Grid container direction="column" padding={2} spacing={2} >
                        <Grid container spacing={1} >
                            <Grid container size={{ xs: 12, sm: 12 }}
                                display="flex" justifyItems="center"

                            >
                                <Grid size={{ xs: 12, sm: 12 }} >
                                    <Grid size={{ xs: 12, sm: 12 }}>
                                        <Typography variant="h6"> Lista de GMs </Typography>

                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 8 }}>
                                        <hr />
                                    </Grid>
                                </Grid>
                                <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial"  >
                                    <Grid size={{ xs: 12, sm: 6, md: 4 }} alignSelf="center">
                                        <Autocomplete
                                            openText="Abrir"
                                            closeText="Fechar"
                                            noOptionsText="Sem opções"
                                            loadingText="Carregando..."
                                            disablePortal
                                            options={opcoesAutoCompleteUsuario}
                                            loading={isLoading}
                                            disabled={isLoading}
                                            value={autoCompleteSelectedOption}
                                            size={UtilidadeService.isMobile() ? "small" : "medium"}
                                            onChange={(event, newValue) => setSelectedIdComplete(newValue?.codigo)}
                                            popupIcon={isLoading ? <CircularProgress size={28} /> : undefined}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Usuário"
                                                    slotProps={{
                                                        inputLabel: {
                                                            style: {
                                                                fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                            }
                                                        }
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 6, sm: 3, md: 2 }} display={"flex"} justifyContent="center" justifyItems="center" padding={1}>
                                        <Button
                                            color="error"
                                            variant="contained"
                                            disableElevation
                                            style={{ height: UtilidadeService.isMobile() ? "32px" : "38px", alignSelf: "center", display: showBotaoCancelar ? "flex" : "none" }}
                                            onClick={() => handleLimparFiltros()}
                                            endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 14 : 16 }}>clear</Icon>}>
                                            <span style={{ fontSize: UtilidadeService.isMobile() ? 14 : 16 }} >Limpar</span>
                                        </Button>
                                    </Grid>
                                    <Grid size={{ xs: 6, sm: 3, md: 2 }} display={"flex"} justifyContent="center" justifyItems="center" padding={1}>
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            disableElevation
                                            style={{ height: UtilidadeService.isMobile() ? "32px" : "38px", alignSelf: "center" }}
                                            onClick={() => { setShowBotaoCancelar(true); carregarDadosTrofeus(true) }}
                                            endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 14 : 16 }}>search</Icon>}>
                                            <span style={{ fontSize: UtilidadeService.isMobile() ? 14 : 16 }} >Pesquisar</span>
                                        </Button>
                                    </Grid>
                                    <Grid container size={{ xs: 12, sm: 4 }} display={UtilidadeService.isMobile() ? "none" : "flex"} justifyContent={"right"} >
                                        <Grid size={{ xs: 12, sm: 12 }}
                                            style={{
                                                backgroundImage: `url(${showImagemTrofeus})`,
                                                backgroundRepeat: 'no-repeat',
                                                width: '75%',
                                                color: "#fbc02d !important",
                                                height: "155px",
                                                backgroundSize: "300px",
                                                backgroundPositionX: "right",
                                                marginTop: "-65px"


                                            }}>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* <Grid container size={{xs:12, sm:5}}>
                                <Grid  size={{xs:12, sm:12}} >
                                    <img src={showImagemTrofeus} width={330} height={160} />
                                </Grid>
                            </Grid> */}
                            <Grid size={{ xs: 12, sm: 12 }}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {trofeusRows.length > 0 && (
                                    <Box sx={{
                                        height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                        '& .super-app-theme--header': {
                                            backgroundColor: theme.palette.common.black,
                                            color: theme.palette.common.white,
                                        },
                                        '& .super-app.negative': {
                                            color: 'red',
                                            fontWeight: 'bold'
                                        },
                                        '& .super-app.positive': {
                                            fontWeight: '600',
                                        },
                                        '& .super-app-theme--cell': {
                                            color: '#00e676',
                                            fontWeight: '600',
                                        },
                                    }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.posicao}
                                            rows={trofeusRows}
                                            columns={columnsGeral}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 16,
                                                    },
                                                },
                                            }}
                                            columnVisibilityModel={{
                                                codigo: false,
                                            }}
                                            pageSizeOptions={[16, 25, 50, 100]}
                                            disableRowSelectionOnClick
                                            disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ? 12 : 16,
                                            }}

                                        />
                                    </Box>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina >
    )
}

